import styled from 'styled-components';
import { normalizeWidth } from '../../../utils/normalize';

export const Placeholder = styled.input`
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  background-color: transparent;
  border: none;
  outline: none;
`;

export const MasterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  // height: auto;
  max-width: 362px;
`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: row;
  // max-height: 373px;
  height: 100%;
  gap: 16px;
`;

export const CommentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  // max-height: 90px;
`;

export const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // max-height: 87px;
  width: 100%;
  height: 100%;
  margin-left: 8px;
  gap: 4px;
`;

export const CommenterNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const CommenterName = styled.h1`
  font-size: 10px;
`;

export const TimeSinceComment = styled.p`
  font-size: 10px;
  color: #666666;
`;

export const CommentText = styled.p`
  font-size: 11px;
  font-weight: 400;
  height: 100%;
  width: 250px;
  // width: 100%;
`;

export const ResponderContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const LikeCommentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

export const ResponderText = styled.h2`
  color: #313131;
  font-size: 10px;
`;

export const HorizontalIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const IconsDupla = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
`;

export const HideTagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const SubComments = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-height: 373px;
  gap: 16px;
`;

export const SubCommentContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 318px;
  gap: 8px;
  padding-left: 32px;
`;

export const SubCommentText = styled.p`
  font-size: 11px;
  font-weight: 400;
  width: 220px;
`;


export const SubMiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 87px;
  gap: 4px;
`;